const innerHtml = `
    function initESW(gslbBaseURL) {
        embedded_svc.settings.displayHelpButton = true; //Or false
        embedded_svc.settings.language = ''; //For example, enter 'en' or 'en-US'

        embedded_svc.settings.defaultMinimizedText = 'Live Chat'; //(Defaults to Chat with an Expert)
        embedded_svc.settings.disabledMinimizedText = 'Agent Not Available'; //(Defaults to Agent Offline)

        embedded_svc.settings.extraPrechatFormDetails = [
            {
                label: 'First Name',
                transcriptFields: ['FirstName__c'],
                displayToAgent: true,
            },
            {
                label: 'Last Name',
                transcriptFields: ['LastName__c'],
                displayToAgent: true,
            },
            {
                label: 'Mobile',
                transcriptFields: ['Phone__c'],
                displayToAgent: true,
            },
            {
                label: 'Email',
                transcriptFields: ['Email__c'],
                displayToAgent: true,
            },
        ];

        //Contact and Lead search
        embedded_svc.settings.extraPrechatInfo = [
            {
                entityName: 'Contact',
                showOnCreate: true,
                saveToTranscript: 'ContactId',
                entityFieldMaps: [
                    {
                        isExactMatch: false,
                        fieldName: 'MobilePhone',
                        doCreate: false,
                        doFind: true,
                        label: 'Mobile',
                    },
                    {
                        isExactMatch: false,
                        fieldName: 'Phone',
                        doCreate: false,
                        doFind: true,
                        label: 'Phone',
                    },
                    {
                        isExactMatch: true,
                        fieldName: 'Email',
                        doCreate: false,
                        doFind: true,
                        label: 'Email',
                    },
                ],
            },
            {
                entityName: 'Lead',
                showOnCreate: true,
                saveToTranscript: 'LeadId',
                entityFieldMaps: [
                    {
                        isExactMatch: false,
                        fieldName: 'MobilePhone',
                        doCreate: false,
                        doFind: true,
                        label: 'Mobile',
                    },
                    {
                        isExactMatch: false,
                        fieldName: 'Phone',
                        doCreate: false,
                        doFind: true,
                        label: 'Phone',
                    },
                    {
                        isExactMatch: true,
                        fieldName: 'Email',
                        doCreate: false,
                        doFind: true,
                        label: 'Email',
                    },
                ],
            },
        ];

        embedded_svc.settings.enabledFeatures = ['LiveAgent'];
        embedded_svc.settings.entryFeature = 'LiveAgent';

        embedded_svc.init('https://atosmedical.my.salesforce.com', 'https://atosmedical.my.site.com/', gslbBaseURL, '00D3X000002q7Lf', 'Chat_Group_US', {
            baseLiveAgentContentURL: 'https://c.la2-c2-fra.salesforceliveagent.com/content',
            deploymentId: '5727T0000008OLd',
            buttonId: '5737T0000008OJc',
            baseLiveAgentURL: 'https://d.la2-c2-fra.salesforceliveagent.com/chat',
            eswLiveAgentDevName: 'Chat_Group_US',
            isOfflineSupportEnabled: false,
        });
    }

    (function() {
        var style = document.createElement('style');
        style.type = 'text/css';
        style.innerHTML = \`
            .embeddedServiceHelpButton .helpButton .uiButton {
                background-color: #f11111;
                font-family: 'Salesforce Sans', sans-serif;
            }
            .embeddedServiceHelpButton .helpButton .uiButton:focus {
                outline: 1px solid #f11111;
            }
            @font-face {
                font-family: 'Salesforce Sans';
                src: url('https://c1.sfdcstatic.com/etc/clientlibs/sfdc-aem-master/clientlibs_base/fonts/SalesforceSans-Regular.woff') format('woff'),
                    url('https://c1.sfdcstatic.com/etc/clientlibs/sfdc-aem-master/clientlibs_base/fonts/SalesforceSans-Regular.ttf') format('truetype');
            }
        \`;
        document.head.appendChild(style);

        function loadChatbot() {
            if (!window.embedded_svc) {
                var s = document.createElement('script');
                s.setAttribute('src', 'https://atosmedical.my.salesforce.com/embeddedservice/5.0/esw.min.js');
                s.onload = function () {
                    initESW(null);
                };
                document.body.appendChild(s);
            } else {
                initESW('https://service.force.com');
            }
        }

        loadChatbot();
    })();
`;

const createScript = () => {
    console.log('Creating chatbot script for US production environment');

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.innerHTML = innerHtml;
    script.classList.add('consent-dependent-chatbot');
    document.head.appendChild(script);
};

export default createScript;
